import React, {useContext} from "react";
import axios from "axios";
import {Autoplay, FreeMode, Pagination} from 'swiper/modules';
import {Swiper, SwiperSlide} from "swiper/react";
import {Link} from "react-router-dom";
import {VideoContext} from "../../../context/VideoContext";

const HomeProgramlarComponent = () => {
    const {youtubeData} = useContext(VideoContext);

    return(
        <>
            {youtubeData?.playlists &&
                (() => {
                    const excludedTitles = ["EĞİTİM VE SAĞLIK", "ÇALIŞAN ORDUNUN ÜRETEN KADINLARI", "NOTANIN DİLİNDEN", "HAYATIN İÇİNDEN", "SAĞLIKLI GÜNLER", "TARİHİYLE ORDU", "USTANIN ELİNDEN"];
                    return youtubeData.playlists
                        .filter(item => {
                            const title = (item?.title || "").trim();
                            return !excludedTitles.includes(title);
                        })
                        .map((item, index) => {
                            return(
                                <div className="program-list" key={item?.id || index}>
                                    <div className="program-title">
                                        {item?.title}
                                    </div>

                                    <div className="program-content">

                                        <Swiper
                                            slidesPerView={5}
                                            spaceBetween={30}
                                            loop={true}
                                            autoplay={{delay: 2500, disableOnInteraction: false}}
                                            modules={[FreeMode, Pagination, Autoplay]}
                                            className="mySwiper"
                                            breakpoints={{
                                                320: {
                                                    slidesPerView: 1.5,
                                                    spaceBetween: 12,
                                                },
                                                480: {
                                                    slidesPerView: 2,
                                                    spaceBetween: 15,
                                                },
                                                768: {
                                                    slidesPerView: 3,
                                                    spaceBetween: 20,
                                                },
                                                1024: {
                                                    slidesPerView: 4,
                                                    spaceBetween: 25,
                                                },
                                                1280: {
                                                    slidesPerView: 5,
                                                    spaceBetween: 30,
                                                },
                                            }}
                                        >
                                            {item?.videos && item.videos.map((video, vIndex) => {
                                                return(
                                                    <SwiperSlide className="program-items" key={video?.id || vIndex}>
                                                        <Link  to={`/programlar/${video.id}`} className="program-item-link">
                                                            <img src={video.thumbnail} alt={video.title || "program"}/>
                                                        </Link>
                                                    </SwiperSlide>
                                                )
                                            })}
                                        </Swiper>
                                    </div>
                                </div>
                            )
                        })
                })()
            }
        </>
    )
}

export default HomeProgramlarComponent;